<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <div>
        <i class="pi pi-th-large title-card-icon"></i>
      </div>
      <div>
        <p class="mb-0 text-3xl title">{{'menu.organizationTypes' | transloco}}</p>
        <p>{{'menu.descriptions.organizationTypes' | transloco}}</p>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-between">
            <div>
              <button
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                (click)="addOrganizationType = true"
                icon="pi pi-plus"
              ></button>
            </div>
            <div>
              <button (click)="filtersVisible = !filtersVisible" class="p-button-secondary" icon="pi pi-sliders-h"
                      label=" {{'common.filters' | transloco}}"
                      pButton>
              </button>
            </div>
          </div>
        </div>
        <p-table #table [(first)]="first" [(rows)]="rows" [paginator]="true" [value]="organizationTypes" (onFilter)="onFilter($event)"
                 [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [totalRecords]="totalOrganizationTypes"
                 styleClass="p-datatable-striped" editMode="row" dataKey="organizationTypeUuid">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{'attribute.name' | transloco}}</th>
              <th scope="col" class="w-10rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-organizationType let-editing="editing" let-ri="rowIndex">
            <tr *ngIf="!loadingOrganizationTypes" [pEditableRow]="organizationType">
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input id="orgType-{{ri}}" [focus]="editing" appAutoFocus pInputText type="text"
                           [(ngModel)]="organizationType.name" (ngModelChange)="validate($event, 'orgType-' + ri)">
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{organizationType.name}}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <div class="flex justify-content-end">
                  <button
                    *ngIf="!editing"
                    pInitEditableRow
                    (click)="onRowEditInit(organizationType)"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                    [disabled]="organizationType.readOnly"
                  ></button>
                  <button
                    *ngIf="!editing"
                    (click)="confirmAndDelete(organizationType)"
                    pButton
                    pRipple
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                    [disabled]="organizationType.readOnly || organizationType.root"
                  ></button>

                  <button *ngIf="editing"
                          (click)="onRowEditSave(organizationType, ri)"
                          [loading]="persistingChangesEdit"
                          class="p-button-rounded btn-primary-light mr-2"
                          icon="pi pi-check" pButton pRipple
                          type="button" pSaveEditableRow
                          [disabled]="!organizationType.name || organizationType.name.length > 255"
                  ></button>
                  <button *ngIf="editing"
                          (click)="onRowEditCancel(organizationType, ri)"
                          class="p-button-rounded btn-danger-light"
                          icon="pi pi-times" pButton pRipple
                          type="button" pCancelEditableRow></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingOrganizationTypes">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr *ngIf="addOrganizationType">
              <td class="table-footer-form">
                <input id="new" [focus]="addOrganizationType" appAutoFocus pInputText type="text"
                       [(ngModel)]="newOrganizationTypeName" (ngModelChange)="validate($event, 'new')">
              </td>
              <td class="table-footer-form">
                <div class="flex justify-content-end">
                  <button (click)="onRowCreateSave()"
                          [loading]="persistingChangesCreate"
                          class="p-button-rounded btn-primary-light mr-2"
                          icon="pi pi-check" pButton pRipple
                          type="button"
                          [disabled]="!newOrganizationTypeName || newOrganizationTypeName.length > 255"
                  ></button>
                  <button (click)="onRowCreateCancel()"
                          class="p-button-rounded btn-danger-light"
                          icon="pi pi-times" pButton pRipple
                          type="button"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalOrganizationTypes == 0"
                 class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
            <div *ngIf="totalOrganizationTypes > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalOrganizationTypes ? totalOrganizationTypes : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalOrganizationTypes}}
              {{(totalOrganizationTypes > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input (keyup.enter)="filtersVisible = false; applyFilters();" [(ngModel)]="globalFilter"
               [focus]="filtersVisible" appAutoFocus class="w-full" id="name"
               pInputText type="text">
      </div>
    </div>
    <div class="col-12">
      <p-button (onClick)="filtersVisible = false; applyFilters()" [disabled]="!globalFilter"
                label="{{'common.filter' | transloco}}"
                styleClass="p-button-primary mx-2 mt-2" type="button"></p-button>
      <p-button (click)="resetFilters(); filtersVisible = false; applyFilters()" label="{{'common.clear' | transloco}}"
                styleClass="p-button-danger" type="button"></p-button>
    </div>
  </div>
</p-sidebar>
